<template>
  <div class="cart-page" :key="key">
    <router-view/>
    <modals-container />
  </div>
</template>

<script>
import { defineComponent, onBeforeMount, provide, ref } from '@vue/composition-api';
import { eventEmitter, mainStore } from 'partners-widget-core';
import useDeviceCheck from '@/compositions/useDeviceCheck';

export default defineComponent({
  name: 'Root',
  setup(props, ctx) {
    const key = ref(1);
    eventEmitter.on('user-store-changed', () => { key.value = Date.now(); });

    provide('singleSpa', ctx.root.singleSpa);
    useDeviceCheck();

    onBeforeMount(async () => {
      document.documentElement.style.setProperty('--b24-green', mainStore.store.env.brandColor);
      document.documentElement.style.setProperty('--b24-green-dark', mainStore.store.env.brandColor);
      document.documentElement.style.setProperty('--b24-green-light', mainStore.store.env.brandColor);
    });

    return {
      key,
    };
  },
});
</script>

<style>
:root {
  --b24-green-dark: #5a9c51;
  --b24-green: #6ebc63;
  --b24-green-light: #77cc6c;
  --b24-pink: #fe6564;
  --b24-yellow-main: #fcee21;
  --b24-link: #3d70b2;
  --b24-link-hover: #4186df;
  --b24-link-visited: #71a1df;
  --b24-white: rgb(255, 255, 255);
  --b24-black-native: #000000;
  --b24-black: #242424;
  --b24-gray-dark: #7d8290;
  --b24-gray: #aeb4c2;
  --b24-gray-light: #c7ccd7;
  --b24-gray-super-light: #e6e9ed;
  --b24-orange: #f2994a;
  --b24-red-error: #d93133;
  --b24-yellow: #fecb2f;
  --b24-yellow-light: #ffe07a;
}
</style>
